/** Kenney Pico-8 City (CC0) — tilemap.png，8×8 格 + 1px 间距（与 Tiled 一致） */
export const SHEET_COLS = 24
export const SPRITE_SIZE = 8
export const SPRITE_STRIDE = 9

export function spriteRect (index) {
  if (index < 0) return null
  const col = index % SHEET_COLS
  const row = Math.floor(index / SHEET_COLS)
  return {
    sx: col * SPRITE_STRIDE,
    sy: row * SPRITE_STRIDE,
    sw: SPRITE_SIZE,
    sh: SPRITE_SIZE
  }
}
